import { Component } from '@angular/core';
import { HeadquartersProvider } from '../../providers/headquarters'
import {InAppBrowser} from "@ionic-native/in-app-browser";

@Component({
    selector: 'footerbar',
    templateUrl: 'footerbar.html'
})
export class FooterbarComponent {

    private headquarters:Array<any> = [];

    constructor(private model:HeadquartersProvider, private _iab: InAppBrowser) {
    }

    ngOnInit() {
        this.model.get().then((data:Array<any>) => {
            this.headquarters = data;
        });
    }

    public openEzoomWebsite() {
        this._iab.create('http://www.ezoom.com.br/', '_system');
    }

}



// WEBPACK FOOTER //
// ./src/components/footerbar/footerbar.ts